import { FeedbackRowType } from '../types';
import { AbstractRowBuilder } from './AbstractRowBuilder';

export class TextAreaRowBuilder extends AbstractRowBuilder<FeedbackRowType.TextArea> {
  constructor(id: string) {
    super(id, FeedbackRowType.TextArea);
  }

  override isValid() {
    return this.createValidationResponse()
      .withParentValidation(super.isValid())
      .validate();
  }
}
